import { useTranslation } from '../../contexts/LanguageContext'
import type { AppLanguage } from '../../i18n/types'

const languages: { code: AppLanguage; label: string; flag: string }[] = [
  { code: 'es', label: 'ES', flag: '🇪🇸' },
  { code: 'en', label: 'EN', flag: '🇬🇧' },
]

export function LanguageSwitcher() {
  const { language, setLanguage } = useTranslation()

  return (
    <div className="flex items-center bg-slate-100 rounded-lg p-0.5">
      {languages.map((lang) => (
        <button
          key={lang.code}
          onClick={() => setLanguage(lang.code)}
          className={`px-2 py-1 text-xs font-medium rounded-md transition-all ${
            language === lang.code
              ? 'bg-white text-slate-900 shadow-sm'
              : 'text-slate-500 hover:text-slate-700'
          }`}
          title={lang.code === 'es' ? 'Español' : 'English'}
        >
          {lang.label}
        </button>
      ))}
    </div>
  )
}
